import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';

const StatsGroupSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Stats Group Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[

                            {
                                label: "Group Name",
                                key: "groupName",
                            },
                            {
                                label: "Sport",
                                key: "sport",
                                format: "ModelLink",
                            },

                        ]}
                        columnB={[

                        ]}
                        columnC={[
                            {
                                label: "Created On",
                                key: "created",
                                format: "onAndBy",
                            }
                        ]}
                    />

                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default StatsGroupSingleView;
